import React from "react";
import { Col, Container, Image, Navbar, Row } from "react-bootstrap";
import img1 from "./img/simoneBergonzi/questions-bro.svg"
import img2 from "./img/simoneBergonzi/college-project-bro.svg"
import img3 from "./img/simoneBergonzi/writing-room-bro.svg"

function App() {
  const birthDate = new Date('2002-04-23');
  
  const getAge = (dob) => {
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDifference = today.getMonth() - dob.getMonth();
    
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age;
  };

  const age = getAge(birthDate);

  return (
    <div className="App">
      <Navbar className='App-navbar'>
        <Container fluid>
          <Navbar.Brand href="/">
            <button className="nav-neon-button"><span>HOME</span><i></i></button>
          </Navbar.Brand>
        </Container>
      </Navbar>
      <div className="App-screen-black d-flex align-items-center justify-content-center">
        <Container>
          <h1>Meet Simone</h1>
          <Row className="d-flex align-items-center justify-content-center">
            <Col sm={12} md={12} lg>
              <p>
                I am Simone Bergonzi, a {age}-year-old Software Architect and System Administrator. 
                My technical expertise centers around JavaScript/TypeScript and C#, alongside solid hands-on experience with Vue, Node.js, Java, and C++.
                Beyond coding and managing infrastructure, I am a huge fan of RPG video games and draw constant inspiration from the worlds of anime and manga. 
                This passion for both technology and interactive storytelling allows me to bring a unique mix of creativity and analytical thinking to my work. 
                I am driven by curiosity and constantly striving to grow and push boundaries within the software development field.
              </p>
            </Col>
            <Col sm={12} md={12} lg>
              <Image src={img1} style={{height: '100%'}}/>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="App-screen-light-purple d-flex align-items-center justify-content-center">
        <Container>
          <Col>
            <h1>Study and Career Path</h1>
            <Row className="d-flex align-items-center justify-content-center">
              <Col sm={12} md={12} lg>
                <Image src={img2} style={{height: '100%'}}/>
              </Col>
              <Col sm={12} md={12} lg>
                <p>
                  I am a Software Architect and System Administrator with a passion for building secure, scalable infrastructure. 
                  My tech journey began with an IT diploma from ISII Marconi, which led me to join a local software house, LikableHair. 
                  Starting as a full-stack developer focused TypeScript, Node.js, Vue, and Svelte, 
                  I eventually transitioned into my current role architecting solutions and managing Docker environments on Linux systems. 
                  After recently graduating with a Bachelor's degree in Computer Science from UNIPR (108/110), 
                  I am now pursuing a Master's in Cybersecurity at UNITN, bridging the gap between robust software engineering and advanced system security.
                </p>
              </Col>
            </Row>
          </Col>
        </Container>
      </div>
      <div className="App-screen-black d-flex align-items-center justify-content-center">
        <Container>
          <h1>Personal Passions and Hobbies</h1>
          <Row className="d-flex align-items-center justify-content-center">
            <Col sm={12} md={12} lg>
              <p>
                Beyond the world of software development, I lead a vibrant and fulfilling personal life. 
                I am an avid lover of RPG video games, finding inspiration in their immersive storytelling and intricate world-building. 
                In my downtime, I can often be found exploring virtual realms and embarking on epic quests. 
                Additionally, I draw inspiration from anime and manga, appreciating the artistry and narrative depth found in these mediums. 
                Whether I am uncovering hidden treasures in a game or diving into captivating narratives, 
                my personal passions invigorate my creativity and fuel my drive for innovative problem-solving, 
                allowing me to bring a unique perspective to my work as a developer and software architect.
              </p>
            </Col>
            <Col sm={12} md={12} lg>
              <Image src={img3} style={{width: '100%'}}/>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default App;
